import React from "react";
import { useTranslation } from "react-i18next";

function NotFound(props) {
  const { t } = useTranslation();

  return (
    <div className="bg-white min-h-full rounded-lg">
      <div className="max-w-lg mx-auto p-8 text-center">
        <h1 className="inline-block text-2xl sm:text-3xl font-extrabold text-black">
          {t("This page does not exist.")}
        </h1>
        <p className="text-slate-600">
          {t("the page you are looking for could not be found.")}
        </p>
      </div>
    </div>
  );
}

export default NotFound;
